import { PagedStatusHistory } from '@/components/history/PagedStatusHistory';
import { TimeSheetStatusBadge } from '@/components/timesheet/TimeSheetStatusBadge';
import TimeSheetStatusHistoryModel from '@/models/services/TimeSheetStatusHistoryModel';

/**
 * Historique du statut d'une feuille d'heures (badge, date, auteur, motif des refus), paginé côté API : Feuille d'heure
 * et détail d'une feuille. version : la changer recharge (après une action sur la feuille) ; collapsed : replié à
 * l'arrivée, chargé à l'ouverture
 */
export function TimeSheetStatusHistoryBox({
  sheetId,
  version,
  collapsed = false,
}: {
  sheetId: id | number;
  version: number;
  collapsed?: boolean;
}) {
  return (
    <PagedStatusHistory
      collapsed={collapsed}
      modelClass={TimeSheetStatusHistoryModel}
      filters={{ timeSheet: Number(sheetId) }}
      version={version}
      empty="Aucun historique."
      testId="sheet-status-history"
      toLine={(line) => ({
        id: line.id,
        createdAt: line.createdAt,
        createdBy: line.createdBy,
        status: <TimeSheetStatusBadge reference={line.timeSheetStatusReference} label={line.timeSheetStatusLabel} />,
        comment: line.comment,
      })}
    />
  );
}
